import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow p-8">
        <h1 className="text-3xl font-bold mb-8 text-gray-900">Terms of Service</h1>
        
        <div className="space-y-6 text-gray-600">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptance of Terms</h2>
            <p>By accessing or using Linkforce AI Chatbot services, including our AI chatbot embedding service, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Service Description</h2>
            <p>Linkforce AI Chatbot provides an AI-powered chatbot service that can be embedded into websites. Our service includes:</p>
            <ul className="list-disc pl-6">
              <li>Customizable AI chatbot interfaces</li>
              <li>Natural language processing capabilities</li>
              <li>Website integration tools</li>
              <li>Analytics and reporting features</li>
              <li>User management systems</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. User Obligations</h2>
            <p>As a user of our service, you agree to:</p>
            <ul className="list-disc pl-6">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use the service in compliance with all applicable laws</li>
              <li>Not use the service for any illegal or unauthorized purpose</li>
              <li>Not interfere with or disrupt the service or servers</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Intellectual Property</h2>
            <p>All content, features, and functionality of our service, including but not limited to text, graphics, logos, and software, are owned by Linkforce AI and are protected by intellectual property laws.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Payment Terms</h2>
            <ul className="list-disc pl-6">
              <li>Subscription fees are billed in advance on a recurring basis</li>
              <li>All fees are non-refundable unless required by law</li>
              <li>We may change our fees upon reasonable notice</li>
              <li>You are responsible for all applicable taxes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Service Availability and Updates</h2>
            <p>We strive to maintain high availability of our service but do not guarantee uninterrupted access. We may modify, suspend, or discontinue any part of the service at any time with reasonable notice.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Data Usage and Privacy</h2>
            <p>Your use of our service is also governed by our Privacy Policy. By using our service, you consent to our collection and use of data as described in the Privacy Policy.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, Linkforce AI Chatbot shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Termination</h2>
            <p>We may terminate or suspend your access to the service immediately, without prior notice, for any breach of these Terms. Upon termination, your right to use the service will immediately cease.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. We will notify users of any material changes. Your continued use of the service following such modifications constitutes your acceptance of the updated Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Contact Information</h2>
            <p>For any questions about these Terms, please contact us at:</p>
            <p className="mt-2">Email: forbusinessenquiries10@gmail.com</p>
          </section>

          <p className="text-sm text-gray-500 mt-8">Last Updated: {new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 